import { Filter } from '@nemuru-eng/js-api-client';
import React from 'react';

import { AutoLoanList } from '@/components/modules/AutoLoanList/AutoLoanList';

import { ApplicationType } from '../../../../config/types';
import { LoanListByApplicationType } from '../../../modules/LoanListByProduct/LoanListByApplicationType';
import { LoanListSupportedApplicationType } from '../../../modules/LoanListByProduct/types/LoanListSupportedApplicationType';
import { OrderListByApplicationType } from '../../../modules/OrderList/OrderListByApplicationTypeModule';

export const ApplicationListFactory: React.FC<ApplicationListFactory> = ({ applicationType, filters }) => {
  switch (applicationType) {
    case ApplicationType.ORDER:
    case ApplicationType.PAY_BY_LINK:
      return (
        <OrderListByApplicationType
          applicationType={applicationType}
          listProps={{
            additionalFilters: filters,
            reducedWidth: true,
          }}
        />
      );
    case ApplicationType.AUTO:
      return (
        <AutoLoanList
          listProps={{
            additionalFilters: filters,
            reducedWidth: true,
          }}
        />
      );
    default:
      return (
        <LoanListByApplicationType
          applicationType={applicationType as LoanListSupportedApplicationType}
          listProps={{
            additionalFilters: filters,
            reducedWidth: true,
          }}
        />
      );
  }
};

interface ApplicationListFactory {
  applicationType: ApplicationType;
  filters?: Filter[];
}
